<template lang="pug">
button-base.button-logout.font-bold(@click='clickEvent')
  slot
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'

/**
 * ログアウトボタン
 */
@Component({
  components: {
    ButtonBase,
  },
})
export default class ButtonLogout extends Vue {
  private clickEvent(key: Event): void {
    this.$emit('click', key)
  }
}
</script>

<style lang="stylus" scoped>
.button-logout
  width 120px
  height var(--input-height-default)
  padding 10px
  color var(--color-input-logout__text)
  background-color var(--color-input-logout__background)
  border-radius 20px
</style>
